import { gql } from '@apollo/client';
import { BreakdownType } from './JourneyVisitorBreakdown.constant';
import { JourneyVisitorBreakdownRows } from './JourneyVisitorBreakdown.types';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { generateRow } from './journeyVisitorBreakdown.utils';

const journeyVisitorBreakdownQuery = gql`
  query getVisitorsBreakdownQuery($workflowId: Long!, $nodeId: Long, $startTime: Instant, $endTime: Instant, $visitorBreakdownType: VisitorTrackingFilter!, $pagination: Pagination) {
        getVisitorsBreakdown(workflowId: $workflowId, nodeId: $nodeId, startTime: $startTime, endTime: $endTime, visitorBreakdownType: $visitorBreakdownType, pagination: $pagination) {
        nodeId
        visitorsExited {
            enteredAt
            exitedAt
            exitReason
            email
            userId
            exitNodeId
        }
        info {
          count
          offset
          limit
          page
        }
    }
}
`;

type useJourneyVisitorBreakdownProps = {
  workflowId: number;
  nodeId?: number;
  breakdownType: BreakdownType;
  currentPage: number;
  size: number;
  startTime?: string;
  endTime?: string;
};

export const useJourneyVisitorBreakdown = ({
  workflowId,
  nodeId,
  breakdownType,
  currentPage,
  startTime,
  endTime,
  size,
}: useJourneyVisitorBreakdownProps) => {
  const options = useMemo(
    () => ({
      variables: {
        workflowId: workflowId,
        nodeId: nodeId,
        visitorBreakdownType: breakdownType,
        startTime,
        endTime,
        pagination: {
          offset: currentPage,
          limit: size,
        },
      },
    }),
    [workflowId, nodeId, startTime, endTime, breakdownType, currentPage, size],
  );
  const { data, isLoading } = useGraphql(journeyVisitorBreakdownQuery, options);
  const journeyVisitorBreakdown = useMemo(() => {
    return generateRow(data || { getVisitorsBreakdown: {} }) as JourneyVisitorBreakdownRows;
  }, [data]);

  const { count, offset, limit, page } = data?.getVisitorsBreakdown?.info || {};
  return {
    isLoading,
    journeyVisitorBreakdown,
    pageInfo: {
      count,
      offset,
      limit,
      page,
    },
  };
};
